import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { FuitesStatutPipe } from '../../../pipes/fuites-statut.pipe';
import { FuitesPipe } from '../../../pipes/fuites.pipe';

@Component({
  selector: 'app-traitement-data-fuites-mediane-95',
  standalone: true,
  imports: [
    TraitementDataComponent,
    ALaDateDuPipe,
    FuitesStatutPipe,
    FuitesPipe
  ],
  templateUrl: './traitement-data-fuites-mediane-95.component.html',
  styleUrl: './traitement-data-fuites-mediane-95.component.scss'
})
export class TraitementDataFuitesMediane95Component {
  @Input() patient: Patient | undefined;
}
